export const USER = 'ROLE_USER';
export const SUPERVISOR = 'ROLE_SUPERVISOR';
export const ROLE_ROOT = 'ROLE_ROOT';
export const ROLE_USER_MANAGER = 'ROLE_USER_MANAGER';
export const ROLE_GROUP_MANAGER = 'ROLE_GROUP_MANAGER';
export const ROLE_VOD_MANAGER = 'ROLE_VOD_MANAGER';
export const ROLE_STREAM_MANAGER = 'ROLE_STREAM_MANAGER';
export const ROLE_NOTIFICATION_MANAGER = 'ROLE_NOTIFICATION_MANAGER';
export const ROLE_DOCUMENT_MANAGER = 'ROLE_DOCUMENT_MANAGER';
export const ROLE_DOCUMENT_VIEWER = 'ROLE_DOCUMENT_VIEWER';
export const ROLE_VOTE_MANAGER = 'ROLE_VOTE_MANAGER';
export const ROLE_VOTE_VIEWER = 'ROLE_VOTE_VIEWER';
export const ROLE_SETTINGS_MANAGER = 'ROLE_SETTINGS_MANAGER';
export const ROLE_CMS_MANAGER = 'ROLE_CMS_MANAGER';
export const ROLE_REMOTE_CONTROL_MANAGER = 'ROLE_REMOTE_CONTROL_MANAGER';
